import styled from 'styled-components';

const EsriWebMap = styled.div`
  #esri-web-map {
    width: 100%;
    border: 0;
    height: 100%;
  }
`;

export default { EsriWebMap };
